import React from "react";
import "./Our_Blog.css";
import Homepage_common_heading from "../../Common-Component/Homepage_common_heading/Homepage_common_heading";

const Our_Blog = () => {
  const data = [
    {
      label: "From Business Cards to T-Shirts: Complete Branding Solutions",
      img: "/assets/Images/Home/blog/img1.png",
    },
    {
      label: "From Business Cards to T-Shirts: Complete Branding Solutions",
      img: "/assets/Images/Home/blog/img2.png",
    },
    {
      label: "From Business Cards to T-Shirts: Complete Branding Solutions",
      img: "/assets/Images/Home/blog/img1.png",
    },
    {
      label: "From Business Cards to T-Shirts: Complete Branding Solutions",
      img: "/assets/Images/Home/blog/img2.png",
    },
    {
      label: "From Business Cards to T-Shirts: Complete Branding Solutions",
      img: "/assets/Images/Home/blog/img1.png",
    },
    {
      label: "From Business Cards to T-Shirts: Complete Branding Solutions",
      img: "/assets/Images/Home/blog/img2.png",
    },
  ];

  return (
    <section className="Our_Blog">
      <div className="custom_container">
        <Homepage_common_heading
          headingText={"Our Latest Blogs"}
          headingDescText={
            "Stay updated with printing tips and promotional ideas."
          }
        />

        <div className="row">
          {data?.map((item) => {
            return (
              <div className="col-xxl-4 col-xl-6 col-sm-6 mb-3">
                <div className="blog_card">
                  <div className="img_holder">
                    <img src={item?.img} className="inner_img" />
                  </div>

                  <div className="overlay"></div>

                  <div className="text_div">
                    <p className="label_text">{item?.label}</p>
                    <p className="read_text">Read more</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Our_Blog;
